import { ISignable } from "@/mixins/SignalsMixin/interfaces";
import {
  BioFlags,
  BioLocation,
  BioSocialNetwork,
  BioStats,
  IBioFlags,
  IBioLocation,
  IBioSocialNetwork,
  IBioStats,
  SignableType
} from "@/services/DTOs";
import { CompletionStage } from "./CompetionStage";

export interface IPersonBio {
  id: string | undefined;
  ggId: string;
  publicId: string | undefined;
  subjectId: number | undefined;
  name: string;
  email: string;
  hasEmail: boolean;
  phone: string | undefined;
  completion: number;
  completionStage: CompletionStage;
  weight: number;
  verified: boolean;
  picture: string;
  pictureThumbnail: string;
  professionalHeadline: string;
  stats: IBioStats;
  flags: IBioFlags;
  links: IBioSocialNetwork[];
  location: IBioLocation | undefined;
}

export class PersonBio implements ISignable {
  public id: string | undefined;
  public ggId: string;
  public publicId: string | undefined;
  public subjectId: number | undefined;
  public name: string;
  public email: string;
  public hasEmail: boolean;
  public phone: string | undefined;
  public completion: number;
  public completionStage: CompletionStage;
  public weight: number;
  public verified: boolean;
  public picture: string;
  public pictureThumbnail: string;
  public professionalHeadline: string;
  public stats: BioStats;
  public flags: BioFlags;
  public links: BioSocialNetwork[];
  public location: BioLocation | undefined;

  constructor(data: IPersonBio) {
    this.id = data.id;
    this.ggId = data.ggId;
    this.subjectId = data.subjectId;
    this.publicId = data.publicId;
    this.name = data.name;
    this.email = data.email;
    this.hasEmail = data.hasEmail;
    this.phone = data.phone;
    this.completion = data.completion;
    this.completionStage = data.completionStage;
    this.weight = data.weight;
    this.verified = data.verified;
    this.picture = data.picture;
    this.pictureThumbnail = data.pictureThumbnail;
    this.professionalHeadline = data.professionalHeadline;
    this.stats = data.stats;
    this.flags = data.flags;
    this.links = data.links;
    this.location = data.location;
  }

  public firstName(): string {
    return this.name ? this.name.replace(/ .*/, "") : "";
  }

  public signableId(): string | undefined {
    return this.publicId;
  }

  public signableType(): SignableType {
    return SignableType.Person;
  }
}
